import type { IStyleFunctionOrObject } from '@fluentui/react';
import type {
  IOnboardingHubCardStyleProps,
  IOnboardingHubCardStyles,
} from '@m365-admin/onboarding-hub';

export function getOnboardingHubCardStyles(
  props: IOnboardingHubCardStyleProps,
): IStyleFunctionOrObject<IOnboardingHubCardStyleProps, IOnboardingHubCardStyles> {
  const { theme } = props;

  const styles: Partial<IOnboardingHubCardStyles> = {
    commandButton: (() => ({
      i: {
        color: theme.palette.neutralPrimary,
      },
    }))(),
  };

  return styles;
}
